import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';
import { SidebarCategoryItem, SidebarSubcategoryItem } from './fusion-ui-sidebar.interfaces';
import { NavigationProvider } from '@nrwl/navigation-abstract';
const listItemsStructure = require('./fusion-ui-sidebar.json');

@Injectable({
  providedIn: 'root'
})
export class FusionSidebarService {
  constructor(private readonly navigator: NavigationProvider) {}

  /**
   * Prepares the sidebar items (ids)
   */
  public prepareListItems(): SidebarCategoryItem[] {
    const listItems = cloneDeep(listItemsStructure);

    listItems.forEach(item => {
      item.id = `${item.type}(${item.typeId})/(${item.outlet}:${item.navigation})`;
      if (item.submenu) {
        item.submenu.forEach(subItem => {
          subItem.id = `${subItem.type}(${subItem.typeId})/(${subItem.outlet}:${subItem.navigation})`;
        });
      }
    });

    return listItems;
  }

  public findIdsByRoutesId(
    listItems: SidebarCategoryItem[],
    categoryRouteId: string,
    subcategoryRouteId: string
  ): { categoryId; subcategoryId } {
    let categoryId = null;
    let subcategoryId = null;

    for (let i = 0; i < listItems.length; i++) {
      if (listItems[i].routeId === categoryRouteId && listItems[i].id) {
        categoryId = listItems[i].id;
      }

      if (listItems[i].submenu) {
        const subcategoryItem = listItems[i].submenu.find(el => el.routeId === subcategoryRouteId);
        if (subcategoryItem && subcategoryItem.id) {
          subcategoryId = subcategoryItem.id;
          if (!categoryId) {
            // assuming category if is too generic - can be overwritten by the first condition
            categoryId = listItems[i].id;
          }
        }
      }
    }

    return { categoryId, subcategoryId };
  }

  /**
   * Get category and subcategory ids
   * @param listItems The menu items list
   * @param url The current router url
   */
  public getSelectedIds(
    listItems: SidebarCategoryItem[],
    url: string
  ): { categoryId; subcategoryId } {
    const urlArgs = this.extractUrlArgs(url);

    let categoryRoutingId = urlArgs && urlArgs.length ? urlArgs[0].key : null;
    let subCategoryRoutingId = urlArgs && urlArgs.length ? urlArgs[0].value : null;

    if (categoryRoutingId === 'dashboard' && subCategoryRoutingId === 'landing-page') {
      categoryRoutingId = 'landing-page';
      subCategoryRoutingId = null;
    }

    if (categoryRoutingId === 'dashboard' && subCategoryRoutingId === 'test-list-management') {
      categoryRoutingId = 'test-list-management';
      subCategoryRoutingId = null;
    }

    return this.findIdsByRoutesId(listItems, categoryRoutingId, subCategoryRoutingId);
  }

  /**
   * Determine active Outlet
   * @param {SidebarCategoryItem | SidebarSubcategoryItem} item - An item from sidebar (category or subcategory)
   */
  public determineActiveOutlet(item: SidebarCategoryItem | SidebarSubcategoryItem): string {
    if (item.type === 'perspective') {
      return item.outlet ? item.outlet : 'dashboard';
    }

    if (['wizards'].indexOf(item.type) !== -1) {
      return item.type;
    }

    return 'dashboard';
  }

  /**
   * Extract arguments from the URL
   * @param url The given url
   */
  public extractUrlArgs(url: string): { key: string; value: string }[] {
    const routingSequence = url.match(/\(([\w-:/]+)\)/);
    return routingSequence
      ? routingSequence[1].split(/[/]{1,2}/).map(sequence => {
          const [key, value] = sequence.split(':');
          return { key, value };
        })
      : [];
  }

  /**
   * Navigate to dashboard
   * @param view
   */
  navigateOutlet(view: string[]): void {
    this.navigator.navigateToDashboard(view);
  }
}
